import React from 'react';

// Components
import UserPortalNavBar from '../UserPortal/UserPortalNavBar'

const ADMIN_NAV_TABS = [
  {
    title: 'Profiles',
    slug: 'profiles',
    path: `/admin/profiles`
  },
  {
    title: 'Users',
    slug: 'users',
    path: `/admin/users`
  }
]

const AdminNav = ({ currentSection }) => (
  <nav className="locker-nav">
    <UserPortalNavBar
      currentTab={currentSection}
      tabs={ADMIN_NAV_TABS}
    />
  </nav>
)
export default AdminNav;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminNav.js